<template>
  <a-modal
    :visible="visible"
    :footer="null"
    width="70%"
    centered
    destroyOnClose
    @cancel="closeDialog"
    :maskClosable="false"
    class="request-providers-modal"
  >
    <template slot="title">
      Pedidos da cotação #{{ cotId }}
    </template>

    <cc-loader
      v-if="loading"
      style="margin-top: 20vh; max-height: none !important;"
    />

    <div v-else id="printMe" class="request-provider-table-size">
      <div style="display:flex;align-items:center">
        <img
          src="@/assets/Logotipo.png"
          class="only-print request-print-logo"
        >

        <span class="only-print request-print-title">
          Fornecedores da cotação #{{ cotId }}
        </span>
      </div>

      <div class="request-providers__table-container">

        <a-table
            :columns="columns"
            :dataSource="orderedProviders"
            :pagination="false"
            :loading="loading"
            :rowKey="record => record.produto_id"
            size="small"
        >
            <template slot="seller" slot-scope="text, record">
                {{ record.vendedor_nome || '-' }}<br>
                {{ record.vendedor_email || '-' }}
            </template>

            <template slot="phone" slot-scope="text, record">
                <cc-whatsapp :phone="record.vendedor_telefone" />
            </template>

            <template slot="payment" slot-scope="text, record">
                {{ record.entrega ? record.entrega.forma : '-' }}
            </template>

            <template slot="deliveryDate" slot-scope="text, record">
                {{
                    record.entrega?.data_entrega
                        ? formatDate(record.entrega.data_entrega)
                        : '-'
                }}
            </template>

            <template slot="minimumBilling" slot-scope="text, record">
                {{
                    record.entrega?.faturamento_minimo
                        ? record.entrega.faturamento_minimo.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            minimumFractionDigits: 2
                        })
                        : '-'
                }}
            </template>

            <template slot="observation" slot-scope="text, record">
                <a-tooltip
                    v-if="record.entrega?.observacao"
                    :title="record.entrega.observacao"
                >
                    <a-icon
                        type="info-circle"
                        style="color: var(--primary-color)"
                    />
                </a-tooltip>

                <span v-else>-</span>
            </template>

            <template slot="status" slot-scope="text, record">
                <div class="table-not-typed" v-if="record.status == 'NOT_TYPED'">
                    Não digitada
                </div>

                <div class="table-typed" v-else-if="record.status == 'TYPED'">
                    Digitada
                </div>

                <div class="table-freezed" v-else-if="record.status == 'FROZEN'">
                    CONGELADA
                </div>

                <div class="table-created" v-else-if="record.status == 'ORDERED'">
                    Pedido Gerado
                </div>

                <div class="table-nooffer" v-else-if="record.status == 'NOT_OFFERED'">
                    SEM OFERTA
                </div>
            </template>

            <template slot="actions" slot-scope="text, record">
                <a-tooltip title="Exportar pedido">
                    <a-icon
                        type="download"
                        class="export-icon"
                        @click="exportItem(record)"
                    />
                </a-tooltip>
            </template>
        </a-table>
      </div>
    </div>
  </a-modal>
</template>
<script>
import QuotationService from "@/services/QuotationService";
import ProviderService from "@/services/v3/providers/profile.service";
import { mapState } from "vuex";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    cotId: {
      type: [Number, String],
      required: true,
    },
  },

  mixins: [loaderMixin],

  computed: {
    ...mapState(["statuses"]),

    orderedProviders() {
      return this.providers.filter(item => item.status === "ORDERED");
    },
  },

  data() {
    return {
      loading: false,
      service: new QuotationService(),
      providerService: new ProviderService(),
      providers: [],
    };
  },

  created() {
    if (this.visible) {
      this.loadProviders();
    }
  },

  computed: {
      ...mapState(["statuses"]),

      orderedProviders() {
          return this.providers.filter(item => item.status === "ORDERED");
      },

      columns() {
          return [
              {
                  title: "Fornecedor",
                  dataIndex: "fornecedor_nome",
                  key: "fornecedor_nome",
                  customRender: text => text || "-"
              },
              {
                  title: "Vendedor / Email",
                  key: "seller",
                  scopedSlots: { customRender: "seller" }
              },
              {
                  title: "Telefone",
                  key: "phone",
                  align: "center",
                  scopedSlots: { customRender: "phone" }
              },
              {
                  title: "Cond. Pgto.",
                  key: "payment",
                  scopedSlots: { customRender: "payment" }
              },
              {
                  title: "Data Entrega",
                  key: "deliveryDate",
                  align: "center",
                  scopedSlots: { customRender: "deliveryDate" }
              },
              {
                  title: "Fat. Min.",
                  key: "minimumBilling",
                  align: "right",
                  scopedSlots: { customRender: "minimumBilling" }
              },
              {
                  title: "Obs.",
                  key: "observation",
                  align: "center",
                  scopedSlots: { customRender: "observation" }
              },
              {
                  title: "Status",
                  key: "status",
                  align: "center",
                  scopedSlots: { customRender: "status" }
              },
              {
                  title: "",
                  key: "actions",
                  align: "center",
                  scopedSlots: { customRender: "actions" }
              }
          ];
      }
  },

  methods: {
    closeDialog() {
      this.$emit("close");
    },

    formatDate(date) {
      if (!date) return "-";

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    exportItem(item) {
      this.providerService
        .exportItem(this.cotId, item.id_fornecedor)
        .then(resp => {
          const FileSaver = require("file-saver");

          const blob = new Blob([resp.data], {
            type: "text/plain;charset=utf-8",
          });

          FileSaver.saveAs(
            blob,
            `Relatorio-${this.$route.params.id}.csv`
          );
        });
    },

    async loadProviders() {
      this.loading = true;

      try {
        const request = await this.service.get_request_providers(this.cotId);
        this.providers = request.data.concorrentes;
      } finally {
        this.loading = false;
      }
    },

    getSpecialBackground(index) {
      return index % 2 !== 0 ? "page-table-line-special" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.request-providers-modal {
  .ant-modal {
    max-width: 95vw;
  }

  .ant-modal-body {
    padding: 16px 24px 24px;
  }

  .request-providers__table-container {
    width: 100%;
    max-height: 65vh;
    overflow: auto;
  }

  /* Cabeçalho da tabela */
  .ant-table-thead > tr > th {
    background: #FFFEFC;
    color: #605F5F;
    border-bottom: 1px solid #E5E5E5;
    font-weight: 600;
  }

  /* Corpo */
  .ant-table-tbody > tr > td {
    color: #605F5F;
    font-weight: 300;
    border-bottom: 1px solid #E5E5E5;
  }

  /* Zebra igual ao modal antigo */
  .ant-table-tbody > tr:nth-child(even) > td {
    background: #F7F7F7;
  }

  /* Hover discreto */
  .ant-table-tbody > tr:hover > td {
    background: #F7F7F7 !important;
  }

  .export-icon {
    cursor: pointer;
    font-size: 18px;
    color: lightblue;
    transition: .2s;

    &:hover {
      color: var(--primary-color);
    }
  }

  .table-not-typed,
  .table-typed,
  .table-freezed,
  .table-created,
  .table-nooffer {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 110px;
    padding: 4px 12px;
    border-radius: 10px; // igual ao antigo
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .table-not-typed {
    background: lightcoral;
    color: #fff;
  }

  .table-typed {
    background: lightgreen;
    color: #fff;
  }

  .table-freezed {
    background: gray;
    color: #fff;
  }

  .table-created {
    background: lightblue;
    color: #fff;
  }

  .table-nooffer {
    background: transparent;
    border: 1px solid gray;
    color: #605F5F;
  }
}
</style>
